// fr.gestionpial.user.services.UserProfileServiceI generated by ic2 no-version-available at Thu Oct 01 15:16:26 UTC 2026
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { IRPC, JSONSerializer, JSONRpcRequest, JSONRpcResponse, RpcRequestBuilder } from '@ic2/ic2-lib';

@Injectable({
  providedIn: 'root',
})
export class UserProfileService {
  private irpc = inject(IRPC);

  changePassword = (oldPassword: string, newPassword: string): RpcRequestBuilder<void> => {
    const req = new JSONRpcRequest();
    req.method = 'UserProfileService.changePassword';
    req.params = [];
    req.params.push(
      JSONSerializer.toJSON(oldPassword, 'java.lang.String', null, false)
    );
    req.params.push(
      JSONSerializer.toJSON(newPassword, 'java.lang.String', null, false)
    );
    return new RpcRequestBuilder(this.irpc, req, null);
  };

  updateProfile = (firstName: string, lastName: string): RpcRequestBuilder<void> => {
    const req = new JSONRpcRequest();
    req.method = 'UserProfileService.updateProfile';
    req.params = [];
    req.params.push(
      JSONSerializer.toJSON(firstName, 'java.lang.String', null, false)
    );
    req.params.push(
      JSONSerializer.toJSON(lastName, 'java.lang.String', null, false)
    );
    return new RpcRequestBuilder(this.irpc, req, null);
  };

}
